import { render } from "./ClientReg.vue?vue&type=template&id=5f5116b8&scoped=true"
import script from "./ClientReg.vue?vue&type=script&lang=js"
export * from "./ClientReg.vue?vue&type=script&lang=js"

import "./ClientReg.vue?vue&type=style&index=0&id=5f5116b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5116b8"]])

export default __exports__